// ============================
// CONFIGURACIÓN CALENDARIO
// ============================
const PARQUE_CERRADO = "parque-cerrado";
let   PARQUE_ABIERTO = "parque-abierto";
const LABEL_CERRADO = "Parque Cerrado";
const LABEL_ABIERTO = "parque abierto";
let   LABEL_DISPONIBLE = "pasaporte disponible";
const LABEL_NO_DISPONIBLE = "pasaporte no disponible";
const PASAPORTE_NO_DISPONIBLE = "sin-pasporte";

const FORMATO_FECHA_CALENDARIO = "m/d/yy";

// ► RANGO: hoy → 30 de junio de 2026
const HOY = new Date();
HOY.setHours(0,0,0,0);
const MAXIMO_FECHAS_MOSTRAR = new Date(2026, 5, 30); // 30/jun/2026

let fechasDeshabilitadas = []; // YYYY-MM-DD cerrados (derivadas de tu `fechas`)
let fechasPasaporte = [];      // YYYY-MM-DD disponibles p/ pasaporte (si activas esa lógica)
let colorPasaporte = "#B7B7B7";
let isOpen = false;
let isTerra = true; // usa verificarDisponibilidad (abierto/cerrado simple)

// --- EXCEPCIÓN: SIEMPRE ABIERTO 24/09 del año actual ---
const Y_ACTUAL = new Date().getFullYear();
const EXCEPCIONES_ABIERTAS = new Set([`${Y_ACTUAL}-09-24`]);
function esExcepcionAbiertaISO(iso) { return EXCEPCIONES_ABIERTAS.has(iso); }

// ============================
// MAPAS / IDs / CLASES
// ============================
const UrlsPasaporte = {
  FECHAS_TERRA: "https://grupopanaca.com.do/EscenarioApi/api/calendario",
};

const ClasesPasaporte = {
  ABIERTO:"parque-abierto",
  travesia :"pasaporte-travesia",
  NATURA : "pasaporte-natura",
  TERRA : "pasaporte-terra",
  TERRA_NINO : "pasaporte-terra-nino",
  GRANJERO : "pasaporte-granjero",
  CAMPO: "pasaporte-campo",
  TERRA_NATURA :"pasaporte-natura",
};

const IdsPasaportes = {
  ABIERTO:"8561612685531a",
  TERRA: "8561612685531",
  travesia: "8561613471963",
  NATURA: "8561616388315",
  GRANJERO: "8680180711643",
  INFANTIL: "8675970285787",
  CAMPO: "8561615274203",
  CAMPOINFANTIL: "8752678502619",
  TERRA_NATURA: "8561617535195",
  FIESTA: "9393078534427",
  PLAZA: "9393078534427"
};

const ColorPasaporte = {
  TERRA:"#116736",
  TERRA_NINO : "#EC890A",
  NATURA : "#116736",
  travesia : "#AC6B3A",
  GRANJERO : "#E2725B",
  ABIERTO: "#FFF",
};

const Pasaportes = {
  ABIERTO:"Parque Abierto",
  TERRA :"Pasaporte Terra",
  TERRA_NINO :"Pasaporte Terra Niño",
  NATURA : "Pasaporte Natura",
  travesia : "Pasaporte Travesía",
  GRANJERO : "Pasaporte Granjero",
  CAMPO : "Pasaporte Campo",
  TERRA_NATURA : "Pasaporte Terra + Natura",
};

// ============================
// UTILIDADES DE FECHA
// ============================
function formatearFecha(fecha) {
  const year = fecha.getFullYear();
  const month = String(fecha.getMonth() + 1).padStart(2, '0');
  const day = String(fecha.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function formatoFechaMesDiaAnio(lista) {
  return (Array.isArray(lista) ? lista : []).map((item) => {
    if (item?.Fecha) {
      const [mes, dia, anio] = item.Fecha.split('/');
      return `${anio}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    }
    return null;
  }).filter(Boolean);
}

function obtnerFechaLarga(fecha){
  const f = new Date(fecha);
  const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
  return f.toLocaleDateString('es-ES', opciones);
}

// ============================
// CARGA DE CERRADOS (DESDE TU VARIABLE GLOBAL `fechas`)
// ============================
async function diaCerrado() {
  try {
    // Usa tu variable global `fechas` (formato m/d/yyyy en item.Fecha)
    const base = Array.isArray(fechas) ? fechas : [];

    // Convierte a ISO y aplica excepciones
    const fechasConvertidas = formatoFechaMesDiaAnio(base);
    fechasDeshabilitadas = fechasConvertidas.filter(f => !esExcepcionAbiertaISO(f));
  } catch(error){
    // En caso de error, no bloquea nada
    fechasDeshabilitadas = [];
  }
}

// ============================
// OBTENER FECHAS DESDE URL (utilitario, por si lo usas)
// ============================
async function obtenerFechas(url){
  try{
    const respuesta = await fetch(url);
    if(!respuesta.ok){
      if (respuesta.status === 404) throw new Error('404 Not Found');
      throw new Error(`Error: ${respuesta.status} ${respuesta.statusText}`);
    }
    return await respuesta.json();
  }catch{
    return '404 Not Found';
  }
}

// ============================
// beforeShowDay: CERRADO/ABIERTO simple
// ============================
function verificarDisponibilidad(date) {
  const formatted = formatearFecha(date); // YYYY-MM-DD
  if (date < HOY) return [true, 'fecha-anterior', 'Fecha Anterior'];

  // EXCEPCIÓN: siempre abierto
  if (esExcepcionAbiertaISO(formatted)) return [true, PARQUE_ABIERTO, LABEL_ABIERTO];

  if (fechasDeshabilitadas.includes(formatted)) return [false, PARQUE_CERRADO, LABEL_CERRADO];

  return [true, PARQUE_ABIERTO, LABEL_ABIERTO];
}

// ============================
// beforeShowDay: lógica de PASAPORTES (si quisieras activarla)
// ============================
function fechasNodisponible(date) {
  const formattedDate = formatearFecha(date);

  if (esExcepcionAbiertaISO(formattedDate)) return [true, PARQUE_ABIERTO, LABEL_ABIERTO];
  if (fechasDeshabilitadas.includes(formattedDate)) return [false, PARQUE_CERRADO, LABEL_CERRADO];
  if (date < HOY) return [true, 'fecha-anterior', 'Fecha Anterior'];

  const esFechaPermitida = (fechasPasaporte || []).some(fecha => {
    const [anio, mes, dia] = fecha.split("-").map(n => parseInt(n,10));
    return date.getDate() === dia && date.getMonth() === (mes - 1) && date.getFullYear() === anio;
  });

  return esFechaPermitida
    ? [true, colorPasaporte, LABEL_DISPONIBLE]
    : [true, PASAPORTE_NO_DISPONIBLE, LABEL_ABIERTO];
}

// ============================
// onSelect: setea fecha y oculta modal
// ============================
function eventosCalendario(dateText, inst){
  const pasaportes = document.querySelectorAll(".section-pasaportes__slide-card");

  // ✅ No re-asignes la variable, usa el elemento
  const di = document.getElementById("dateInput");
  if (di) {
    di.value = dateText;
    di.textContent = dateText;
    di.dispatchEvent(new Event('change'));
  }
  /*
  if(dateInput.value == fechaEspecial){
    document.getElementById('textDiscount').style.display = "none"
  }else{
    document.getElementById('textDiscount').style.display = "flex"
  }*/

  const contCompra = document.getElementById('container-compra-ahora');
  const contBtns = document.getElementById('container-buttons');
  document.getElementById('btn-buy-header').style.display = "none"
  if (contCompra) contCompra.style.zIndex = '1';
  if (contBtns) {
    contBtns.style.zIndex = '2';
    contBtns.style.display = 'flex';
  }

  const btnLoad = document.getElementById('loadSillas');
  if (btnLoad) btnLoad.click();

  // ticketSelected es un array, ej: [8], [9], [10]
  const idSeleccionado = Array.isArray(ticketSelected) ? ticketSelected : ticketSelected;

  // 🔹 Mapeo de IDs a nombres
  let nombreZona = "";
  switch (Number(idSeleccionado)) {
    case 8:  nombreZona = "Experience"; break;
    case 9:  nombreZona = "Preferred";  break;
    case 10: nombreZona = "Premium";    break;
    default: nombreZona = "";           break;
  }

  // 🔹 Formateo final (primera letra mayúscula)
  const ticketSelectedShow = nombreZona
    ? nombreZona.charAt(0).toLocaleUpperCase('es-ES') + nombreZona.slice(1).toLocaleLowerCase('es-ES')
    : "";

  const primero = document.getElementById('primero');
  if (primero) primero.innerHTML = "Travesía " + ticketSelectedShow;

  // 🔹 Radios/checkbox por zona
  if (idSeleccionado != null) {
    ['10','9','8'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.checked = false;
    });
    const marcar = (id) => {
      const el = document.getElementById(String(id));
      if (el) el.checked = true;
    };
    if (idSeleccionado === 10) marcar(10);
    else if (idSeleccionado === 9) marcar(9);
    else if (idSeleccionado === 8) marcar(8);
  }

  // Atributo data-fecha en tarjetas
  pasaportes.forEach((pasaporte) => pasaporte.setAttribute("data-fecha", dateText));

  validarPasaportes(dateText);

  // Limpieza de modales/contenido especial
 // document.querySelectorAll('.openModalConcierto').forEach(el => el.remove());

  ocultarModal();
}

// ============================
// CONFIG / INIT Datepicker
// ============================
function configuracionesCalendario(){
  return{
    dateFormat: FORMATO_FECHA_CALENDARIO,
    changeMonth: true,
    changeYear: true,
    minDate: HOY,
    maxDate: MAXIMO_FECHAS_MOSTRAR,
    beforeShowDay: verificarDisponibilidad, // lógica simple abierto/cerrado
    onSelect: eventosCalendario,
    language: 'es'
  };
}

async function inicializarDatepicker() {
  await diaCerrado(); // ► llena fechasDeshabilitadas desde TU `fechas`
  const cfg = configuracionesCalendario();
  $("#datepicker").datepicker(cfg);
}

// ============================
// VALIDACIÓN PASAPORTES (placeholder)
// ============================
async function validarPasaportes(/*fecha*/){
  // Si quisieras usar fechasPasaporte por tipo, llénala y usa fechasNodisponible
}

// ============================
// MODAL
// ============================
function cargarCalendario() {
  document.addEventListener('DOMContentLoaded', ()=>{
    const modal = document.querySelector('.modal');
    if (modal) modal.style.setProperty('display', 'flex');
  });
}

function ocultarModal() {
  const modal = document.querySelector("#myModal");
  ocultarChat();
  if (modal) modal.style.display = 'none';
}

function closeTextModal(){
   const m = document.getElementById('myModal');
   if (m) m.style.display = "none";
   document.body.style.overflow = 'auto';
}

// ============================
// Nomenclaturas (UI) — NO toca `fechasDeshabilitadas`
// ============================
async function fechasDisponibilidadPasaporte(){
  const nomenclatura = document.querySelector(".color-nomenclatura__cerrado");
  const nombrePasaporte = document.querySelector(".etiqueta-nomenclatura");
  const diaSinPasporte = document.querySelector(".color-nomenclatura__abierto");
  const nomenClaturaOculta = document.querySelector(".fila-nomenclatura__oculto");

  if (nomenclatura) nomenclatura.style.setProperty("background-color", "#fff");
  if (diaSinPasporte) diaSinPasporte.style.setProperty("background-color", "red");

  // Estado base: Parque Abierto (leyenda UI)
  if (nombrePasaporte) nombrePasaporte.textContent = Pasaportes.ABIERTO;
  if (nomenclatura) nomenclatura.style.setProperty("background-color", ColorPasaporte.ABIERTO);
  colorPasaporte = ClasesPasaporte.ABIERTO;
  PARQUE_ABIERTO = "parque-abierto";
  isTerra = true;
  isOpen = true;
  LABEL_DISPONIBLE = Pasaportes.ABIERTO;
  if (nomenClaturaOculta) nomenClaturaOculta.style.setProperty("opacity", 0);

  // NO recalculamos `fechasDeshabilitadas` aquí
  renderizarCalendario(isTerra);
}

// ==========================
// Configuración (usa tu contenedor real si no es <body>)
// ==========================
var OBS_CONT_DATEPICKER = document.body;
var dpObserverIniciado = false;
var dpObserver = null;

// ==========================
// Helper: comprobar plugin y nodo
// ==========================
function pluginYNodoListos() {
  return !!(window.jQuery && $.fn && $.fn.datepicker && document.getElementById('datepicker'));
}

// ==========================
// Observer para re-inicializar si #datepicker reaparece/reemplaza
// ==========================
function onMutacionesDatepicker(mutationsList, observer) {
  var el = document.getElementById('datepicker');
  if (el && el.dataset.dpInit !== '1' && pluginYNodoListos()) {
    // Re-engancha usando el último valor de 'terra' que hayas usado; ajusta si necesitas otro
    renderizarCalendario(true);
  }
}

function iniciarObserverDatepicker() {
  if (dpObserverIniciado) return;
  dpObserver = new MutationObserver(onMutacionesDatepicker);
  dpObserver.observe(OBS_CONT_DATEPICKER, { childList: true, subtree: true });
  dpObserverIniciado = true;
}

// =============================
// FUNCIÓN: renderizarCalendario
// =============================
async function renderizarCalendario(terra, intentos) {
  // Valor por defecto si no se pasa
  if (typeof intentos !== 'number') intentos = 0;

  // (1) Esperar a que exista el plugin y el input
  if (!pluginYNodoListos()) {
    if (intentos > 30) return; // evita bucle infinito
    setTimeout(renderizarCalendario, 1000, terra, intentos + 1);
    return;
  }

  // (2) Definir función beforeShowDay
  var beforeFn = terra ? verificarDisponibilidad : fechasNodisponible;

  // (3) Si no es terra, cargar fechas cerradas
  if (!terra) {
    try {
      await diaCerrado();
    } catch (e) {
      if (intentos > 30) return;
      setTimeout(renderizarCalendario, 500, terra, intentos + 1);
      return;
    }
  }

  // (4) Revalidar nodo *después* del await
  var el = document.getElementById('datepicker');
  if (!el || !document.documentElement.contains(el)) {
    if (intentos > 30) return;
    setTimeout(renderizarCalendario, 500, terra, intentos + 1);
    return;
  }

  // (5) Reforzar que no sea null ni vacío
  if (!el) return;
  var $dp = jQuery(el);
  if (!$dp.length) return;

  // (6) Si el datepicker ya está inicializado, destruirlo con seguridad
  if ($dp.hasClass('hasDatepicker')) {
    try {
      $dp.datepicker('destroy');
    } catch (err) {
      console.warn('No se pudo destruir datepicker anterior:', err);
    }
  }

  // (7) Inicializar el nuevo datepicker
  try {
    $dp.datepicker({
      dateFormat: FORMATO_FECHA_CALENDARIO,
      changeMonth: true,
      changeYear: true,
      language: 'es',
      minDate: HOY,
      maxDate: MAXIMO_FECHAS_MOSTRAR,
      beforeShowDay: beforeFn,
      onSelect: eventosCalendario
    });
  } catch (errorInit) {
    console.error('Error al inicializar datepicker:', errorInit);
    if (intentos < 30) setTimeout(renderizarCalendario, 800, terra, intentos + 1);
    return;
  }

  // (8) Marcar el elemento como inicializado
  el.dataset.dpInit = '1';

  // (9) Iniciar observer solo una vez
  try {
    iniciarObserverDatepicker();
  } catch (observerErr) {
    console.warn('Error iniciando observer datepicker:', observerErr);
  }
}

// =============================
// FUNCIÓN: pluginYNodoListos()
// =============================
// Verifica que el plugin jQuery UI Datepicker y el nodo existan
function pluginYNodoListos() {
  return (
    typeof jQuery !== 'undefined' &&
    typeof jQuery.fn !== 'undefined' &&
    typeof jQuery.fn.datepicker === 'function' &&
    document.getElementById('datepicker')
  );
}


// ==========================
// Llamadas iniciales (ajusta 'true/false' según tu lógica)
// ==========================
iniciarObserverDatepicker();
renderizarCalendario(true);



// ============================
// LISTENERS GENERALES
// ============================
function clicksCalendarioPasaportes(){
  document.addEventListener('change', (event)=>{
    if (event.target.matches('.contenedor-eventos__select')) {
      fechasDisponibilidadPasaporte();
    }
  });
}

function clicsksDocument(){
  document.addEventListener('click', (event)=>{
    if (event.target.matches('.buttonCompraAhoraHeader, .section-pasaportes__redirecion')) {
      location.reload();
    }
  });
}

function ocultarChat() {
  const chatButton = document.querySelector("button.chat-toggle.chat-toggle--icon-button");
  if (chatButton) chatButton.style.display = "none";
}

document.addEventListener("click",(e)=>{
  if(e.target.className == "modal"){
    // aquí tu lógica si hace falta
  }
});

// ============================
// ARRANQUE
// ============================
clicksCalendarioPasaportes();
clicsksDocument();
inicializarDatepicker();       // ► lee TU `fechas` y crea el calendario (hoy → 30/jun/2026)
fechasDisponibilidadPasaporte(); // UI de leyenda (no toca cerrados)
